export default __webpack_public_path__ + "static/media/flag.3d6c826f.png";